var map = {
	"./mobile/ProductDetailsView.vue": [
		4732,
		4559,
		9224,
		1019
	],
	"./web/ProductDetailsView.vue": [
		738,
		4559,
		9224,
		6183
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2721;
module.exports = webpackAsyncContext;